import { useEffect, useState } from "react";
import { Lock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

const LoginForm = ({ onOk }) => {
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const r = await fetch(`${API}/login`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ password: pwd }) });
      if (r.ok) return onOk();
      const d = await r.json().catch(() => ({}));
      setErr(d.detail || "Password non corretta");
    } catch {
      setErr("Impossibile contattare il server. Riprova.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="gate-card" data-testid="gate-form">
      <div className="w-11 h-11 rotate-45 border border-[var(--gold)] flex items-center justify-center mb-8 ml-2">
        <Lock size={16} className="-rotate-45 text-[var(--gold-light)]" />
      </div>
      <div className="kicker !text-[var(--gold-light)] mb-3">Documento riservato · PartnerTech</div>
      <h1 className="font-display text-4xl sm:text-5xl text-[var(--cream)] leading-tight">Bella Napoli</h1>
      <p className="text-sm text-[rgba(247,241,230,0.7)] mt-2 mb-8">Piano di Sviluppo Tecnologico e Scalabilità</p>
      <label htmlFor="gate-pwd" className="kicker !text-[var(--gold-light)] block mb-2">Password di accesso</label>
      <input id="gate-pwd" data-testid="gate-password-input" type="password" autoComplete="current-password" autoFocus required maxLength={256} value={pwd} onChange={(e) => setPwd(e.target.value)} className="gate-input" />
      {err && <p role="alert" data-testid="gate-error" className="text-sm text-[#F0B9A8] mt-3">{err}</p>}
      <button type="submit" disabled={busy} data-testid="gate-submit-btn" className="gate-btn">
        {busy && <Loader2 size={16} className="animate-spin" />} {busy ? "Verifica…" : "Entra nel documento"}
      </button>
    </form>
  );
};

const hasSession = () =>
  fetch(`${API}/me`, { credentials: "include" })
    .then((res) => res.ok)
    .catch(() => false);

export const Gate = ({ children }) => {
  const [state, setState] = useState("checking");
  useEffect(() => {
    let alive = true;
    hasSession().then((ok) => alive && setState(ok ? "open" : "locked"));
    return () => {
      alive = false;
    };
  }, []);
  if (state === "open") return children;
  return (
    <div className="gate" data-testid="gate-screen">
      {state === "checking" ? <Loader2 className="animate-spin text-[var(--gold)]" /> : <LoginForm onOk={() => setState("open")} />}
    </div>
  );
};
